import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, catchError, defer, from, map, mergeMap, of, timeout } from 'rxjs';
import { I18nAppCode } from '../service/backoffice';
import { I18nPackClient } from '../service/i18n-pack.client';
import { toApiLanguage } from './languages';
import { parseLanguagePack } from './backend-language-pack';

// Runtime UI translations come only from the backend. ngx-translate caches each
// loaded locale and uses the backend English package for missing translations.
@Injectable()
export class UiTranslationLoader extends TranslateLoader {
  constructor(private readonly client: I18nPackClient) {
    super();
  }

  override getTranslation(language: string): Observable<Record<string, string>> {
    const locale = toApiLanguage(language) ?? 'en';
    return defer(() => this.client.getGenerate(I18nAppCode.Deliordering, locale)).pipe(
      mergeMap(response => {
        const data = response.result?.data;
        if (!data || typeof data.text !== 'function') throw new Error('UI language package is missing its file content.');
        return from(data.text());
      }),
      map(parseLanguagePack),
      timeout(8000),
      catchError(error => {
        console.warn('UI language package unavailable; falling back to English/source text.', locale, error);
        // Never block startup or invent local translations. Missing English
        // values naturally render their existing English source keys.
        return of({});
      })
    );
  }
}
